var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.488 9.147c0-.018.013-.036.012-.054l-4.883 4.705 4.877 4.554c.003-.032-.006-.065-.006-.099V9.147zm-5.616 5.374l-1.993 1.918a.52.52 0 01-.717.006l-1.988-1.852-4.909 4.731c.12.043.248.076.382.076h13.74c.2 0 .387-.06.55-.15l-5.065-4.729z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.512 15.346l7.451-7.178A1.13 1.13 0 0019.388 8H5.647c-.274 0-.525.106-.72.269l7.585 7.077zM4.5 9.322v8.931c0 .103.024.202.05.296l4.847-4.668L4.5 9.32z"
  })));
}

export default SvgMail;